import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  getLiveDetailAction,
  setLiveDetail,
} from "../../../store/slices/liveDetailSlice";
import { verifyGoogleMeetCode } from "../../../services/goLive";
import { toastMessage } from "../../../utils/toastMessage";

const GoogleMeet = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParam, setSearchParam] = useSearchParams();
  const [code, setCode] = useState(searchParam.get("code") || "");

  const verifyCodeHandler = async () => {
    try {
      const { data } = await verifyGoogleMeetCode(code);
      const { success, data: meetAuthData, message } = data;
      toastMessage(message, success ? "success" : "error", "verifyCodeHandler");
      if (success) {
        dispatch(setLiveDetail( meetAuthData ));
        navigate("/dashboard/profile?tab=Meet");
        // http://13.235.137.221/logical_chat_web_build/#/
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    if (code) {
      verifyCodeHandler();
    }
  }, [code]);

  return <div>GoogleMeet</div>;
};

export default GoogleMeet;
